module.exports = __webpack_public_path__ + "static/mastering-the-core-teachings-of-the-buddha-51e64accac757da5164b6d21eaba3d04.jpg";